import { useEffect } from 'react';
import { useFormState } from 'react-final-form';

import useWizardContext from '@swf/core/hooks/useWizardContext';

import type { FormValues } from '../utils/common';

const useSaveFormFields = () => {
  const { values } = useWizardContext<undefined, FormValues>();
  const { values: formValues } = useFormState();

  useEffect(() => {
    Object.keys(formValues).forEach((key) => {
      values[key] = formValues[key];
    });
  }, [formValues, values]);
};

export default useSaveFormFields;
